import type { GridPrefColumn } from "./apply-grid-prefs.ts";

/**
 * Merges canonical default prefs with saved user prefs.
 *
 * Saved values win for user-controlled fields (`isVisible`, `widthSize`,
 * `ordinalPosition`), while `visibility` always comes from defaults so
 * deployment-visibility updates continue to apply for users with stale prefs.
 *
 * Any saved entries not present in defaults are preserved for forward
 * compatibility.
 */
export const mergeGridPrefs = (
	defaults: GridPrefColumn[],
	saved: GridPrefColumn[] = [],
): GridPrefColumn[] => {
	const defaultsByField = new Map(
		defaults.map((pref) => [pref.columnId, pref]),
	);
	const savedByField = new Map(saved.map((pref) => [pref.columnId, pref]));

	const mergedById = new Map<string, GridPrefColumn>();
	for (const def of defaults) {
		const savedPref = savedByField.get(def.columnId);
		mergedById.set(
			def.columnId,
			savedPref ? { ...savedPref, visibility: def.visibility } : def,
		);
	}

	for (const savedPref of savedByField.values()) {
		if (!defaultsByField.has(savedPref.columnId)) {
			mergedById.set(savedPref.columnId, savedPref);
		}
	}

	return [...mergedById.values()];
};
